import { render, staticRenderFns } from "./AssetUpload.vue?vue&type=template&id=1ae4ff1b&scoped=true"
import script from "./AssetUpload.vue?vue&type=script&lang=js"
export * from "./AssetUpload.vue?vue&type=script&lang=js"
import style0 from "./AssetUpload.vue?vue&type=style&index=0&id=1ae4ff1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4ff1b",
  null
  
)

export default component.exports